import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

export function useGroupedFilterList<T extends { filterGroup?: string }>(
  filterList: MaybeRefOrGetter<Record<string, T>>,
  groupOrder: MaybeRefOrGetter<string[]>,
  favorites: MaybeRefOrGetter<string[]>,
) {
  return computed(() => {
    const groups: Record<string, Record<string, T>> = {}
    const order = toValue(groupOrder)
    const list = toValue(filterList)
    const favSet = new Set(toValue(favorites))

    for (const group of order) {
      groups[group] = {}
    }

    for (const [key, filter] of Object.entries(list)) {
      if (favSet.has(key)) {
        groups['favorites'][key] = filter
      }
      groups[filter.filterGroup][key] = filter
    }

    return Object.fromEntries(
      Object.entries(groups).filter(([, items]) => Object.keys(items).length > 0)
    )
  })
}
